<template>
  <create-course-layout title="ویرایش دوره" :submitFunction="UpdateCourse"/>
</template>
<script>
import {mapActions} from 'vuex';
import CreateCourseLayout from "./CreateLayout.vue";


export default {
  name: "CourseEdit",
  components: {CreateCourseLayout},
  methods: {
    ...mapActions({
      UpdateCourse: "Course/updateCourse"
    })
  }
};
</script>
<style scoped>
.direction {
  direction: rtl;
}

.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}
</style>